var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHeaderSearch = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.045 19.6374C6.25876 19.6374 2.45474 15.8334 2.45474 11.0472C2.45474 6.25963 6.25876 2.45567 11.045 2.45567C15.8313 2.45567 19.6353 6.25963 19.6353 11.0472C19.6353 15.8334 15.8313 19.6374 11.045 19.6374ZM26.6322 24.9133L19.6355 17.918C21.1096 16.0772 22.0904 13.6236 22.0904 11.0464C22.0904 4.90983 17.1819 0 11.0452 0C4.90853 0 0 4.90983 0 11.0464C0 17.1817 4.90853 22.0915 11.0452 22.0915C13.6224 22.0915 16.0774 21.2316 17.9183 19.6366L24.9136 26.6318C25.1595 26.8777 25.5276 27 25.7722 27C26.0181 27 26.3863 26.8777 26.6322 26.6318C27.1226 26.1414 27.1226 25.4051 26.6322 24.9133Z",
    fill: "#222222"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHeaderSearch, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/header-search.c33b8ce3.svg";
export { ForwardRef as ReactComponent };